<template>
    <span :class="classes" style="cursor: pointer" v-tooltip="{content, placement, targetClasses, loadingClass, template}"></span>
</template>

<script>
export default {
  name: 'AlertIcon',
  props: {
    title: String,
    type: {
      type: String,
      default: 'warning'
    },
    placement: {
      type: String,
      default: 'auto'
    },
    size: {
      type: Number,
      default: 20
    }
  },
  computed: {
    classes: function () {
      return `cursor-pointer mdi mdi-alert mdi-${this.size}px text-${this.type}`
    },
    content: function () {
      return this.title
    },
    targetClasses: function () {
      return this.type
    },
    loadingClass: function () {
      return this.type
    },
    template: function () {
      return `<div class="tooltip ${this.type}"><div class='tooltip-arrow'></div><div class='tooltip-inner'>${this.content}</div></div>`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/utils/AlertIcon.vue